import { render, staticRenderFns } from "./BtnMulti.vue?vue&type=template&id=05cd5e5e&"
import script from "./BtnMulti.vue?vue&type=script&lang=js&"
export * from "./BtnMulti.vue?vue&type=script&lang=js&"
import style0 from "./BtnMulti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports